import React from 'react';

interface TopStripeCardProps {
    title: string;
    value: string;
}

const TopStripeCard: React.FC<TopStripeCardProps> = ({
    title,
    value,
}) => {
    return (
        <div className="expert-stats__top-stripe__card">
            <div className="expert-stats__top-stripe__card__title">{title}</div>
            <h3 className="expert-stats__top-stripe__card__value">{value}</h3>
        </div>
    );
};

export default TopStripeCard;
